import { render } from "./MfgMaterialConfirm.vue?vue&type=template&id=450b4104&scoped=true"
import script from "./MfgMaterialConfirm.vue?vue&type=script&lang=js"
export * from "./MfgMaterialConfirm.vue?vue&type=script&lang=js"

import "./MfgMaterialConfirm.vue?vue&type=style&index=0&id=450b4104&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450b4104"]])

export default __exports__